import { createSelector } from '@reduxjs/toolkit';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';

const selectCustomerState = (state) => {
  return state.customers;
};

export const selectCustomerById = (customerId) =>
  createSelector([selectCustomerState], (state) => {
    return state.customers.entities[customerId];
  });

export const selectCustomerEntities = createSelector(
  [selectCustomerState],
  (state) => {
    console.log('selectCustomerEntities:', state.customers);
    return state.customers.entities;
  }
);

export const selectCustomerArray = createSelector(
  [selectCustomerEntities],
  (customers) => Object.values(customers)
);

export const selectCustomerArrayWithoutDeleted = createSelector(
  [selectCustomerArray],
  (customers) => customers.filter((customer) => !customer.deletedAt)
);

export const selectCustomerArrayBySelectedProjectBusinessId = createSelector(
  [selectCustomerArrayWithoutDeleted, selectSelectedProject],
  (customers, project) =>
    customers.filter((customer) => customer.businessId === project.business_id)
);

export const selectCustomerIdMapBySelectedProjectBusinessId = createSelector(
  [selectCustomerArrayBySelectedProjectBusinessId],
  (customers) =>
    customers.reduce((acc, customer) => {
      acc[customer.id] = customer;
      return acc;
    }, {})
);

export const selectCustomerArrayByBusinessId = (businessId) =>
  createSelector([selectCustomerArrayWithoutDeleted], (customers) => {
    return customers.filter((customer) => customer.businessId === businessId);
  });
